import React from 'react';
import VRMViewerWrapper from './VRMViewerWrapper';
import FloatingPanel from './FloatingPanel';
import FrictionDraggable from './FrictionDraggable';

function App() {
  return (
    <div>
      <VRMViewerWrapper />
    </div>
  );
}

export default App;